import { AdUnitFormat } from "@store";
import * as React from "react";
import "./AdFormatDetails.css";
import { ReportLabel } from "./ReportLabel";
import { AdTypeDetails } from "./AdTypeDetails";
import { ChartDataResponse, MetricInfo } from "@api/common";
import * as cn from "classnames";

export interface AdFormatDetailsProps {
    adFormat: AdUnitFormat;
    adTypeDetailsMetrics: MetricInfo[];
    data: ChartDataResponse;
}

export interface AdFormatDetailsState {
    isExpanded: boolean;
}

export class AdFormatDetails extends React.Component<AdFormatDetailsProps, AdFormatDetailsState> {
    constructor(props: AdFormatDetailsProps, context?: any) {
        super(props, context);

        this.state = {
            isExpanded: true
        };
    }

    render() {
        const { adFormat, adTypeDetailsMetrics, data } = this.props;
        const { isExpanded } = this.state;
        return (
            <div className="AdFormatDetails">
                <div className="AdFormatDetails__header">
                    <ReportLabel title={adFormat.name} subtitle={adFormat.size} />
                </div>
                <img className="AdFormatDetails__image" src={adFormat.icon} />
                <div className="AdFormatDetails__content">
                    <div className={cn("AdFormatDetails__content-header")} onClick={this.toggleContent}>
                        <span className={cn("AdFormatDetails__content-header-icon", { open: isExpanded })}>&nbsp;</span>
                    </div>
                    {isExpanded && (
                        <div className="AdFormatDetails__type-list">
                            {adFormat.types.map(adt => (
                                <AdTypeDetails
                                    adFormat={adFormat}
                                    adType={adt}
                                    data={data}
                                    metrics={adTypeDetailsMetrics}
                                    key={adt.name}
                                    className="AdFormatDetails__type-details"
                                />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    private toggleContent = () => this.setState({ isExpanded: !this.state.isExpanded });
}
